import React from "react";
import "./ShipmentManagementSubHeader.scss";
import { Button } from "antd";

const ShipmentManagementSubHeader = ({ bookingList, removeFromBookingList, clearBookingList }) => {


  if (!bookingList.length) return <></>

  return (
    <div className="ShipmentManagementSubHeader">
      <div className="booking-wrapper">
        {
          bookingList.map((booking, index) => {
            return (
              <div key={index} className="booking">
                <div>
                  {booking}
                </div>
                <Button onClick={() => removeFromBookingList(booking)} className="close"></Button>
              </div>
            )
          })
        }
      </div>

      <Button className="clear" onClick={clearBookingList}>Clear</Button>
    </div>
  )

}

export default ShipmentManagementSubHeader;
